const STORAGE_KEY = 'lichess.preferences';

export type LichessPreferences = {
  /** Personal access token from lichess.org/account/oauth/token */
  apiToken: string;
  /** Optional override; otherwise resolved from /api/account when loading games. */
  username: string;
};

const DEFAULTS: LichessPreferences = {
  apiToken: '',
  username: '',
};

export function loadLichessPreferences(): LichessPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<LichessPreferences>;
    return {
      apiToken: typeof parsed.apiToken === 'string' ? parsed.apiToken : '',
      username: typeof parsed.username === 'string' ? parsed.username : '',
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveLichessPreferences(prefs: LichessPreferences): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}
